import { Box } from "@mui/system"
import {useTheme} from "@mui/material/styles"
import CategoryButton from "component/Buttons/CategoryButton"
import { categoryPillGroupSx } from "component/Input/categoryPillStyles"
import AddCoinButton from "component/Buttons/AddCoinButton"
import CryptoRow from "component/CryptoRow"
import BottomTab from "component/BottomTab"
import AddCrypto from "component/Modal/AddNewCrypto"
import { useState, useEffect, useMemo, useCallback, useLayoutEffect } from "react"
import axios from "axios"
import { getPortfolio } from "api/crypto"
import { Typography, useMediaQuery } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { AssetsDetail } from ".."
import addEvent from "utils/addEvent"
import { setLive } from "redux/reducer/crypto"
import AssetsEmptyLayout, { AssetsEmptyListPreview } from "component/AssetsEmptyLayout"
export const Assets = () => {
    const theme=useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState({ allData: [], category: 'All' });
    const [selected,setSelected]=useState(null);
    const { plan } = useSelector(state => state.user);
    const category=useSelector(state=>state.crypto.category)
    const dispatch=useDispatch();

    useEffect(() => {
        fetchAll();
        let timer = setInterval(() => {
           fetchAll();
        }, 120000)
        addEvent('Assets Page')
        return () => { clearInterval(timer); }
    }, []);

    const filterData = useMemo(() => {
        return data.category=='All'?data.allData: data.allData.filter(obj => obj.categoryId == data.category);
    }, [data.allData, data.category])

    const activeCoin = useMemo(() => {
        if (selected) return selected;
        if (!isMobile && filterData.length) return filterData[0];
        return null;
    }, [selected, isMobile, filterData]);

    useLayoutEffect(() => {
        if (isMobile) return;

        if (!filterData.length) {
            setSelected(null);
            return;
        }

        setSelected((current) => {
            if (current && filterData.some((coin) => coin.symbol === current.symbol)) {
                return filterData.find((coin) => coin.symbol === current.symbol) || filterData[0];
            }
            return filterData[0];
        });
    }, [filterData, isMobile]);

    const fetchAll = useCallback(() => {
       getPortfolio()
            .then(res => {
                const assets = res.data.data[0]?.assets || [];
                setData((prev) => ({ ...prev, allData: assets }));
                dispatch(setLive(res.data.updatedPrice));
                setSelected((current) => {
                    if (!current) return current;
                    return assets.find((obj) => obj.symbol === current.symbol) || current;
                });
            })
    }, [dispatch])
    
    const isPortfolioEmpty = data.allData.length === 0;
    const isFilterEmpty = filterData.length === 0;

    const changeCategory = (id) => {
        setData({ ...data, category: id })
    }
    const toggle = () => setVisible(prev => !prev)
    return (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: 'calc(100vh - 60px)', alignItems: 'flex-start' }}>
        <Box sx={{
            width: { xs: '100%', md: '45%', lg: '20%', minWidth: 360 },
            flexShrink: 0,
            position: { md: 'sticky' },
            top: { md: 64 },
            alignSelf: { md: 'flex-start' },
            maxHeight: { md: 'calc(100vh - 64px)' },
            overflowY: { md: 'auto' },
            borderRight: isPortfolioEmpty ? { md: '1px solid rgba(255,255,255,0.14)' } : undefined,
        }}>
           {plan?.name=='Pro' &&
           <Box sx={{ my: 1.5, px: 1, ...categoryPillGroupSx }}>
           <CategoryButton selected={data.category=='All'} onClick={() => {changeCategory('All') }}   text='All' />
           {category.map(({name,_id})=>(
            <CategoryButton key={_id} selected={data.category==_id} onClick={() =>changeCategory(_id)}   text={name} />
           ))}
           
           {/* <CategoryButton selected={data.category=='BigCap'} onClick={() => {changeCategory('BigCap') }} text='BigCap' />
           <CategoryButton selected={data.category=='De-Fi'} onClick={() => changeCategory('De-Fi')} text='DeFi' />
           <CategoryButton selected={data.category=='NFT'} onClick={() => {changeCategory('NFT') }} text='MetaVerse' />
           <CategoryButton selected={data.category=='Metaverse'} onClick={() => {changeCategory('Metaverse')}} text='Gaming' />
           <CategoryButton selected={data.category=='LowCap'} onClick={() => {changeCategory('LowCap')}} text='HighX' /> */}
           <AddCrypto refresh={fetchAll} visible={visible} setVisble={setVisible} />
       </Box>
           } 
            
            <Box sx={{ paddingBottom: 10 }}>
                {isPortfolioEmpty && <AssetsEmptyListPreview />}
                {!isPortfolioEmpty && isFilterEmpty && (
                    <Box sx={{ px: 2, py: 2 }}>
                        <Typography sx={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, textAlign: 'center' }}>
                            No coins in this category
                        </Typography>
                    </Box>
                )}
                {isMobile && isPortfolioEmpty && (
                    <AssetsEmptyLayout onAddClick={toggle} compact />
                )}
                {filterData.map((obj) => (
                    <CryptoRow
                        key={obj._id || obj.symbol}
                        selected={activeCoin?.symbol === obj.symbol}
                        data={obj}
                        setSelected={setSelected}
                        {...obj}
                    />
                ))}
            </Box>
            <BottomTab />
        </Box>
        {!isMobile && (
         <Box sx={{ flex: 1, minWidth: 0, overflow: 'visible' }}>
         {activeCoin ? (
            <AssetsDetail fetchAll={fetchAll} selected={activeCoin} />
         ) : isPortfolioEmpty ? (
            <AssetsEmptyLayout onAddClick={toggle} />
         ) : isFilterEmpty ? (
            <Box sx={{ width: '100%', height: '100%', display: 'grid', placeContent: 'center', px: 3 }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 18, textAlign: 'center' }}>
                No coins in this category yet. Add a coin or pick another filter.
            </Typography>
         </Box>
         ) : (
            <Box sx={{ width: '100%', height: '100%', display: 'grid', placeContent: 'center' }}>
            <Typography sx={{ color: '#3B4C77', fontStyle: 'black', fontSize: 70 }}>Select a Coin</Typography>
         </Box>
         )}
         </Box>
        )}

        </Box>
    )
}


